import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IClientAllocationActions, IThunkGetRelatedClients } from '../types';

const onGetRelatedClients: IThunkGetRelatedClients = thunk(
  async ({ setRelatedClients }: Actions<IClientAllocationActions>, payload) => {
    const { clinicId, actTeamId } = payload;

    const relatedClients = await api.clientAllocation
      .getRelatedClients(clinicId, actTeamId)
      .then(r => r.data);

    setRelatedClients(relatedClients);
  },
);

export default onGetRelatedClients;
